// utils/analytics.js - 클라이언트 사이드 analytics (배치 전송)

import { get } from 'svelte/store';
import { session } from '../stores/session.js';

const API_BASE = import.meta.env.VITE_API_BASE || 'https://api.scantodesk.app';
const BATCH_SIZE = 5;
const FLUSH_INTERVAL = 30_000; // 30s

let queue = [];
let flushTimer = null;

/**
 * Track an analytics event (batched).
 * @param {string} eventType
 * @param {Record<string, unknown>} [properties]
 */
export function trackEvent(eventType, properties) {
  const sessionId = get(session)?.device_id;
  queue.push({ eventType, platform: 'web', sessionId, properties, _ts: Date.now() });

  if (queue.length >= BATCH_SIZE) {
    flush();
  } else if (!flushTimer) {
    flushTimer = setTimeout(flush, FLUSH_INTERVAL);
  }
}

/**
 * Send all queued events to the server.
 */
export function flush() {
  if (flushTimer) {
    clearTimeout(flushTimer);
    flushTimer = null;
  }

  if (queue.length === 0) return;

  const batch = queue.splice(0);

  for (const event of batch) {
    const { _ts, ...payload } = event;
    try {
      fetch(`${API_BASE}/analytics`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(() => {});
    } catch {
      // analytics must never break the app
    }
  }
}

// Flush on page unload
if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush();
  });
}
